module.exports = __webpack_public_path__ + "files/medium.5db47f01bbbb6afc9c800a657bc21a92.png";